import { FC, useCallback } from 'react';
import { format } from 'date-fns';
import { es, enUS } from 'date-fns/locale';

import { useTranslate } from 'hooks/useTranslate';
import { Notification } from 'types/Notification';

import { DATE_FORMAT_WITH_TIME_ALT } from 'constants/defaultConstants';

import IncentivesMarketNotificationsItem from './IncentivesMarketNotificationsItem';
import { Tabs } from '..';

interface Props {
  notifications: Notification[];
  activeTab: Tabs;
  locale: typeof es | typeof enUS;
  // eslint-disable-next-line no-unused-vars -- callback signature in props type
  onMarkAsRead: (notificationId: string) => void;
}

const IncentivesMarketNotificationsList: FC<Props> = ({
  notifications,
  activeTab,
  locale,
  onMarkAsRead,
}) => {
  const { t } = useTranslate();

  const formatDate = useCallback(
    (d: Date | string) => {
      try {
        return format(new Date(d), DATE_FORMAT_WITH_TIME_ALT, { locale });
      } catch {
        return '';
      }
    },
    [locale]
  );

  if (!notifications.length) {
    return (
      <div
        className={`card-inner bg-lighter text-center py-4 incentives-market-notif-empty ${
          activeTab === Tabs.RECENT ? '' : 'incentives-market-notif-empty-closed'
        }`}
      >
        <em
          className={`icon ni ${
            activeTab === Tabs.RECENT ? 'ni-inbox' : 'ni-archive'
          } fs-1 text-soft`}
        />
        <p className="text-soft mb-0 mt-2">
          {activeTab === Tabs.RECENT
            ? t('IncentivesMarketNotificationsEmptyRecent')
            : t('IncentivesMarketNotificationsEmptyClosed')}
        </p>
      </div>
    );
  }

  return (
    <div className="nk-notify-list incentives-market-nk-notify-list">
      {notifications.map((n) => (
        <IncentivesMarketNotificationsItem
          key={n._id}
          notification={n}
          activeTab={activeTab}
          formatDate={formatDate}
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  );
};

export default IncentivesMarketNotificationsList;
